import React, { useEffect } from 'react';
import Header from '../../components/Header/Header';
import AboutBody from './Body';
import Footer from '../../components/footer/Footer';
import Download from '../../components/download/Download';
import './About.css'
import { useStateValue } from '../../stateprovider';


export default function About() {
    const [{ menu }, dispatch] = useStateValue();
    useEffect(() => {
        dispatch({
            type: "MENU",
            menu: false
        });
        dispatch({
            type: "ACTIVE_NAVIGAtION",
            navigation: 'About'
        })
    }, [])
    return <div className="About">
        <div className='About__Header'>
            <Header />
        </div>
        <div className={(menu === true) ? 'notDisplay' : 'About__Body__Section'}><AboutBody /></div>

        <div className={(menu === true) ? 'notDisplay' : 'About__Footer__Section'}>
            <Download />
            <Footer /></div>
    </div>

}